define('v3/Common/Services/Frontend/moment-wrapper-with-locales',['moment'], function (moment) {
	moment.locale(document.documentElement.lang);
	return moment;
});
